import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { gstChoiceFromValue, gstChoiceLabel, gstChoiceOptions, gstChoiceValue, type GstChoice } from "../domain/gstChoice";

/** The one GST menu (owner 2026-10-18): included, added on top, or none. */
export function GstChoiceField({ value, onChange, initial }: { value: GstChoice; onChange: (c: GstChoice) => void; initial?: GstChoice | null }) {
  return (
    <TextField select label="GST" value={gstChoiceValue(value)} onChange={(e) => onChange(gstChoiceFromValue(e.target.value))} fullWidth>
      {gstChoiceOptions(initial ?? value).map((c) => (
        <MenuItem key={gstChoiceValue(c)} value={gstChoiceValue(c)}>
          {gstChoiceLabel(c)}
        </MenuItem>
      ))}
    </TextField>
  );
}
